// Activity types and labels used across the app

export type ActivityType =
  | 'DRILLING'
  | 'COMPLETION'
  | 'PRODUCTION'
  | 'INTERVENTION';

export const ACTIVITY_LABEL: Record<ActivityType, string> = {
  DRILLING: 'Drilling',
  COMPLETION: 'Completion',
  PRODUCTION: 'Production',
  INTERVENTION: 'Intervention',
};

export const DEFAULT_ACTIVITY_COLORS: Record<ActivityType, string> = {
  DRILLING: '#f97316',
  COMPLETION: '#3b82f6',
  PRODUCTION: '#22c55e',
  INTERVENTION: '#ef4444',
};

